import React from "react";
import { Div, Text, Row, Col, Button, Image } from "atomize";

import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import AnimateLink from "../common/AnimateLink";
import PrimaryButton from "../common/PrimaryButton";

const HomeFooterSection = content => {
  return (
    <Div className="home-footer-section">
      <WebsiteContainer>
        <CustomContainer p={{ xs: "0", md: "2.5rem" }}>
          <Div bg="blueGray" p={{ xs: "6.75rem 0", md: "4.25rem 0 4.5rem" }}>
            <Div textAlign="center">
              <Image
                className="logo"
                src="/images/trend-logo.svg"
                w="auto"
                h={{ xs: "1rem", md: "1.25rem" }}
              />
            </Div>
            <Text
              tag="h2"
              className="footer-text"
              dangerouslySetInnerHTML={{
                __html: content.content.title,
              }}
            ></Text>
            <Div className="footer-action-btn">
              <PrimaryButton
                className="primary-btn"
                bg="white"
                hoverBg="white"
                textColor="black"
                textTransform="none"
                border="none"
                h={{ xs: "2.5rem", md: "3.5rem" }}
                onClick={() =>
                  (window.location.href = content.content.btn.link)
                }
              >
                {content.content.btn.text}
              </PrimaryButton>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    </Div>
  );
};

export default HomeFooterSection;
